import { createRouter,createWebHashHistory } from "vue-router";
import store from "./store";
const routes = [
    {
      name: "Home",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/home")
    },
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/login")
    }
];

const router = createRouter({
  routes,
  // mode : "hash|history",
  // history: createWebHistory()
  history: createWebHashHistory()
});

var isCreated=false;
router.beforeEach((to, _, next) => {
  const authRequiredRoutes = [
    "Home",
    "Accounts",
    "Currencies",
    "Languages",
    "Countries",
    "Workers",
    "Branchs",
    "Customers",
    "Softwares",
    "DestinationTowns",
    "Hotels",
    "HotelMatch",
    "Scans",
    "LocalScans",
    "Operator",
    "OperatorCountries",
    "DepartureCities",
    "OperatorDepartureCities",
    "OperatorHotels",
    "Operators",
    "Providers",
    "CreateListScanItems",
    "Schema",
    "Test",
    "CheckUser",
  ];
  const authNotRequiredRoutes = ["Login"];
  const _isAuthenticated = store.getters._isAuthenticated;

  if (authNotRequiredRoutes.indexOf(to.name) > -1 && _isAuthenticated) next(false);
  if(to.path!="/" && to.path!="/login" && !isCreated){
    var routers=store._state.data.routes;
    if(routers[to.path]!=undefined){
      store._mutations.addTabItem[0](routers[to.path]);
      store._state.data.tabs.selected=routers[to.path].uid;
      isCreated=true;
    }
  }

  if (authRequiredRoutes.indexOf(to.name) > -1) {
    if (_isAuthenticated) next();
    else next({ name: "Login" });
  } else {
    next();
  }
});

export default router;